import ModalFormSalary from "./ModalFormSalary";

export default ModalFormSalary;
